import { render, staticRenderFns } from "./PasswordChangeModalSection.vue?vue&type=template&id=18ca1561"
import script from "./PasswordChangeModalSection.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeModalSection.vue?vue&type=script&lang=ts"
import style0 from "./PasswordChangeModalSection.vue?vue&type=style&index=0&id=18ca1561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports